<div class="page-content">
    <div class="title">
        <h1>{{ title | translate }}</h1>
        <hr>
    </div>
    <div class="justify-center">
        <ng-content></ng-content>
    </div>
</div>
